export default class AjaxPosts {
  constructor(button) {
    this.button = $(button);
    this.archive = this.button.closest('.block-archive').find('.block-archive__posts')
    this.params = this.button.find('datafield').data('ajax_data');
    this.params.initialOffset = (this.params.initialOffset) ? this.params.initialOffset : this.params.offset;
    this.params.offset = this.params.initialOffset;

  }

  ajax() {

    $.ajax({
      method: 'POST',
      url: admin_ajax,
      type: "JSON",
      data: {
        params: this.params,
        postsPerPage: this.initialOffset,
        action: 'load_more_posts',
      },
      success: (res) => {
        this.params.offset = this.params.offset + this.params.initialOffset
        if (res.length === 3) {
          this.addToHtml(res)
        } else if (res.length < 3) {
          this.addToHtml(res)
          this.button.attr('disabled', 'disabled')
        }
      }
    })
  }

  handleSorting(sortButton) {
    this.params.time = $(sortButton).data('sort_type');
    $('.block-archive__sorting').find('.is-active').removeClass('is-active')
    $(sortButton).addClass('is-active');
    this.ajax(this.params);
  }

  addToHtml(posts) {
    if (this.params.time) {
      this.archive.find('.post').each(function () {
        $(this).remove();

      })
    }
    posts.map(({ID, url, title, categories, excerpt, image, publish_date}) => {
      this.archive.append(`
<div class="post" id="post-${ID}">
  <img src="${image}" alt="${title} image">
  <div class="post__content">
    <h4 class="post__category">
        ${categories.map((name) => `<span class="post__category__name">${name}</span>`)}
    </h4>
    <h3 class="post__title">${title}</h3>
    <p class="post__date">${publish_date}</p>
    <p class="post__body">${excerpt}</p>
    <a href="${url}" title="${title}" class="button post__link">Read
    More <svg class="icon icon-button" aria-hidden="true" role="img" version="1.1" xmlns="http://www.w3.org/2000/svg"> <use xlink:href="#icon-button" href="#icon-button"></use> </svg></a>
  </div>
</div>`);
    })
  }
}



// WEBPACK FOOTER //
// ./wp/wp-content/themes/ukrainian-museum-theme/src/scripts/modules/Ajax.js